import { appendStyle, enableStyleSheet } from "./ch-global-stylesheet";
/**
 * It allows to include styles in the shadow-root of chameleon components,
 * for example, to style the scrollbars.
 * Use it in a similar way to the html STYLE tag or
 * referencing an external stylesheet in a similar way to the html LINK tag.
 */
export class ChStyle {
    constructor() {
        this.href = undefined;
    }
    el;
    componentDidLoad() {
        if (this.href) {
            fetch(this.href).then(response => {
                if (response.ok) {
                    response.text().then(style => {
                        appendStyle(style);
                        enableStyleSheet();
                    });
                }
            });
        }
        else {
            appendStyle(this.el.innerText);
            enableStyleSheet();
        }
    }
    static get is() { return "ch-style"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-style.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-style.css"]
        };
    }
    static get properties() {
        return {
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the location of the stylesheet document"
                },
                "attribute": "href",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-style.js.map
